/**
 * @author Eric Otto
 */

module.exports = {
    backLink: document.querySelector('.js-back'),

    init: function ($container) {
        'use strict';

        const backContainer = $container
            ? $container.querySelector('[data-js-back]')
            : document.querySelector('[data-js-back]');

        if (backContainer) {
            this.backLink.setAttribute('href', backContainer.getAttribute('data-js-back'));
            this.backLink.classList.add('active');
        } else {
            this.backLink.classList.remove('active');
        }
    }
};
